import { fetchFaq, fetchStoreData } from "@/api/index";

let pendingStoreFetch = null;

export const actions = {
  FETCH_FAQ: function (context) {
    fetchFaq()
      .then((res) => {
        context.commit("SET_FAQ", res.data);
      })
      .catch((err) => console.log(err));
  },

  // App.vue와 매장찾기가 동시에 불러도 요청은 한 번만 보낸다
  FETCH_STORE: function (context) {
    if (pendingStoreFetch) return pendingStoreFetch;
    pendingStoreFetch = fetchStoreData()
      .then((res) => {
        context.commit("SET_STORE", res.data);
      })
      .catch((err) => console.log(err))
      .finally(() => {
        pendingStoreFetch = null;
      });
    return pendingStoreFetch;
  },
};
